import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import CarContext from '../../context/CarContext'
import { transportIndex, getTransportCost } from '../../../helpers/transportCosts'

import 'leaflet/dist/leaflet.css'
import { priceFormatter } from '../../../helpers/Numbers'


const Location = () => {
    const { car } = useContext(CarContext);

    const branch = car.branch; 
    const coords = [ branch.lat, branch.lon ]
    const hours = JSON.parse(branch.openingHours)
    const mapsUrl = `https://maps.google.com/?q=${ encodeURI( `${branch.street},${branch.zip} ${branch.city} ` ) }`;



    useEffect(() => {
        const L = require("leaflet");
    
        delete L.Icon.Default.prototype._getIconUrl;
    
        L.Icon.Default.mergeOptions({
          iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          iconUrl: require("leaflet/dist/images/marker-icon.png"),
          shadowUrl: require("leaflet/dist/images/marker-shadow.png")
        });
      }, []);


    return (
                <div className="row location">
                    <div className="details">
                        <h2>{ branch.city }</h2>
                        <ul className="hours">
                            <li>
                                <div>Måndag</div>
                                <div>{ shortenHours(hours.monday) }</div>
                            </li>
                            <li>
                                <div>Tisdag</div>
                                <div>{ shortenHours(hours.tuesday) }</div>
                            </li>
                            <li>
                                <div>Onsdag</div>
                                <div>{ shortenHours(hours.wednesday) }</div>
                            </li>
                            <li>
                                <div>Torsdag</div>
                                <div>{ shortenHours(hours.thursday) }</div>
                            </li>
                            <li>
                                <div>Fredag</div>
                                <div>{ shortenHours(hours.friday) }</div>
                            </li>
                            <li>
                                <div>Lördag</div>
                                <div>{ shortenHours(hours.saturday) }</div>
                            </li>
                            <li>
                                <div>Söndag</div>
                                <div>{ shortenHours(hours.sunday) }</div>
                            </li>
                        </ul>
                        <h3>Adress:</h3>
                        <p>{branch.street}<br />{branch.zip} {branch.city}</p>
                        <div className="flex links">
                            <a href={`/anlaggningar/${ makeSlug(branch.name) }/`}>Om anläggningen</a>
                            <a href={mapsUrl} target="_blank" rel="noopener noreferrer">Vägbeskrivning</a>
                        </div>
                        { transportIndex.includes(branch.city) &&
                            <Transport city={branch.city} />
                        }
                    </div>
                    <div className="map">
                        <MapContainer 
                            center={ coords } 
                            zoom={ 16 } 
                            scrollWheelZoom={ false }
                            style={{minHeight:'420px', height: '100%'}}
                        >
                            <TileLayer
                                attribution="&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors"
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={ coords }>
                                <Popup>
                                    <strong>{branch.name}</strong><br />
                                    {branch.street}<br />
                                    {branch.zip} {branch.city}
                                </Popup>
                            </Marker>
                        </MapContainer>
                    </div>



                </div>
    )

}


const Transport = ({ city }) => {
    const [ isOpen, setIsOpen ] = useState(false);
    const [ cost, setCost ] = useState(0);
    const destinationSelect = useRef();

    const handleToggle = useCallback((e) => {
        e.preventDefault();
        setIsOpen(()=>{
            return !isOpen;
        })
    },[isOpen])

    const handleCost = useCallback((e) => {
        const destination = destinationSelect.current.value;

        setCost( ()=> {
            return getTransportCost(city, destination) ?? 0   
        })

    },[ city ])

    return (
        <>
            <div className={`transport-cost${isOpen ? ' open':''}`}>
                <div className="heading" onClick={handleToggle}>
                    <h4>Transportera bilen</h4>
                    <div className="sub-heading">Välj anläggning och se transportkostnad</div>
                </div>
                { isOpen &&
                    <div className="expanded">
                        <div className="disclaimer">Bilbolaget finns över stora delar av landet, från Östhammar i norr till Timrå i norr. Oavsett vilken anläggning den bil du är intresserad av står, kan du hämta den på den anläggning som passar dig bäst. Önskar du få bilen levererad till annan ort i Sverige? Kontakta oss så räknar vi på en offert. </div>
                        <h4>Vad kostar transporten?</h4> 
                        <div className="mt-1">
                            <label>Från</label>
                            <div className="block-text grey">
                                { city }
                            </div>
                        </div>
                        <div className="mt-1">
                            <label>Till</label>
                            <div className="block-text grey select">
                                <select 
                                    ref={destinationSelect} 
                                    className="transport-select"
                                    onChange={handleCost}
                                >
                                    <option value="">Välj anläggning</option>
                                {   transportIndex.map(( destination, index ) => {
                                        return (
                                            <option key={index} value={destination}>{ destination }</option>
                                        )
                                    })
                                }
                                </select>
                            </div>
                        </div>
                        <div className="block-text black my-1 bold">
                            Transportkostnad: { priceFormatter(cost) }*
                        </div>
                        {/* <p className="mt-1">
                            <a href="#test">Läs mer om vår transporttjänst</a>
                        </p>

                        <div className="disclaimer my-1">* Kostnaden kan lorem orem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </div> */}


                    </div>
                }
            </div>
        </>
    )
}


const shortenHours = ({openTo, openFrom}) => {
    if (openFrom === '' || openTo === '') { return 'Stängt' }
    return `${openFrom.replace(':00','')}-${openTo.replace(':00','')}`;
}

const makeSlug = (str) => {
    str = str.replace('Bilbolaget','');
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

export default Location